/** web-studio-sites D7: what the offerings piece's current state requires a drawing to show (nothing with no offering). */
import type { RequiredParts } from '../../contract/required';
import type { OfferingsState } from './contract';

export const requiredParts: RequiredParts<OfferingsState> = (state) =>
  state.offerings.length === 0
    ? []
    : [
        { part: 'list' },
        ...state.offerings.flatMap((o) => [
          { part: 'item', item: o.id, action: 'open' },
          ...['name', 'price'].map((part) => ({ part, item: o.id, in: 'item' })),
        ]),
      ];
